import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { API_BASE } from './lib/api';
import App from './App';
import { AuthProvider } from './state/AuthContext';
import { ThemeProvider } from './state/ThemeContext';
import { I18nProvider } from './i18n';
import './styles/global.css';

// Behind the sandbox preview proxy the app lives under a deep sub-path,
// so history-based routing cannot work there; production uses clean URLs.
const Router = API_BASE.includes('/port/') || window.location.pathname.endsWith('.html') ? HashRouter : BrowserRouter;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <I18nProvider>
          <Router>
            <App />
          </Router>
        </I18nProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
